import { render } from "./movtray-list.vue?vue&type=template&id=19f8b078"
import script from "./movtray-list.vue?vue&type=script&lang=js"
export * from "./movtray-list.vue?vue&type=script&lang=js"

import "./movtray-list.vue?vue&type=style&index=0&id=19f8b078&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__